const paths = {
  main: '/disaster-settings',
};

export default paths;
